<template>
  <b-modal
    id="calculate-order-price"
    ref="calculateOrderPriceRef"
    :hide-header="true">

    <table class="table table-sm">
      <thead>
          <tr>
            <th>费用</th>
            <th>小计</th>
            <th>计算规则</th>
          </tr>
      </thead>
      <tbody>
        <tr v-for="detail in details">
          <td>{{getIncomeTypeDisplay(detail.type)}}</td>
          <td>{{detail.amount}}元</td>
          <td>{{detail.calculation}}</td>
        </tr>
      </tbody>
    </table>
    <div slot="modal-footer" class="w-100">
       总价：{{price}}元
      <button class="btn btn-secondary float-right" @click="$refs.calculateOrderPriceRef.hide();">关闭</button>
   </div>
  </b-modal>
</template>

<script>
import OrderMixin from '@/mixins/order'

function showCalculateOrderPriceModel () {
  this.$refs.calculateOrderPriceRef.show()
  this.$http.get(`/api/orders/${this.orderNo}/price`).then(response => {
    this.details = response.data.data.details
    this.price = response.data.data.price
  })
}

export default {
  name: 'calculate-order-price',
  props: ['orderNo'],
  mixins: [OrderMixin],
  data () {
    return {
      details: [],
      price: 0
    }
  },
  components: {
  },
  methods: {
    showCalculateOrderPriceModel
  }
}
</script>